import React from 'react';
import moment from 'moment';
import { Card } from 'react-bootstrap';

import GenericCardRenderItems from './GenericCardRenderItems';
import GenericSimpleRenderItems from './GenericSimpleRenderItems';

const ComplementoPlataformasTecnologicasServiciosResumen = ({ data = {} }) => {
  return (
    <>
      {!!data.Servicios.DetallesDelServicio && (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Servicios</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>
              {data.Servicios.DetallesDelServicio.map((item) => {
                return (
                  <div key={item.id}>
                    <GenericCardRenderItems
                      key={item.id}
                      data={item}
                      labels={labels}
                    >
                      {item.ComisionDelServicio && (
                        <div className="pt-3">
                          <strong>{'Comisión Del Servicio'}</strong>
                          <GenericSimpleRenderItems
                            data={item.ComisionDelServicio}
                            labels={ComisionDelServicioLabels(item)}
                          />
                        </div>
                      )}

                      {item.ContribucionGubernamental && (
                        <div className="pt-2">
                          <strong>{'Contribución Gubernamental'}</strong>
                          <GenericSimpleRenderItems
                            data={item.ContribucionGubernamental}
                            labels={ContribucionGubernamentalLabels(item)}
                          />
                        </div>
                      )}

                      {item.ImpuestosTrasladadosdelServicio && (
                        <div className="pt-2">
                          <strong>{'Impuestos Trasladados del Servicio'}</strong>
                          <GenericSimpleRenderItems
                            data={item.ImpuestosTrasladadosdelServicio}
                            labels={ImpuestosTrasladadosdelServicioLabels(item)}
                          />
                        </div>
                      )}
                    </GenericCardRenderItems>
                  </div>
                );
              })}
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
};

const labels = [
  {
    label: 'Forma de pago',
    index: 'FormaPagoServ',
  },
  {
    label: 'Tipo de servicio',
    index: 'TipoDeServ',
  },
  {
    label: 'RFC tercero autorizado',
    index: 'RFCTerceroAutorizado',
  },
  {
    label: 'Fecha de servicio',
    index: 'FechaServ',
    render: (FechaServ) => {
      return <>{moment(FechaServ).format('YYYY-MM-DD')}</>;
    },
  },
  {
    label: 'Precio servicio sin iva',
    index: 'PrecioServSinIVA',
  },
];

const ComisionDelServicioLabels = (data = {}) => {
  return [
    {
      label: 'Base de la comisión',
      index: 'Base',
    },
    {
      label: 'Porcentaje',
      index: 'Porcentaje',
    },
    {
      label: 'Importe',
      index: 'Importe',
    },
  ];
};

const ContribucionGubernamentalLabels = (data = {}) => {
  return [
    {
      label: 'Impuesto de contribución',
      index: 'ImpContrib',
    },
    {
      label: 'Entidad Donde Paga La Contribucion',
      index: 'EntidadDondePagaLaContribucion',
    },
  ];
};

const ImpuestosTrasladadosdelServicioLabels = (data = {}) => {
  return [
    {
      label: 'Base del impuesto',
      index: 'Base',
    },
    {
      label: 'Impuesto',
      index: 'Impuesto',
    },
    {
      label: 'Tipo factor',
      index: 'TipoFactor',
    },
    {
      label: 'Tasa o cuota',
      index: 'TasaCuota',
    },
    {
      label: 'Importe',
      index: 'Importe',
    },
  ];
};

export default ComplementoPlataformasTecnologicasServiciosResumen;
